module.exports = __webpack_public_path__ + "img/hall-of-fame_2.c6fed028.jpg";